export default __webpack_public_path__ + "static/media/Mike.55c8c432.svg";